import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "../api/axios";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { login } = useContext(AuthContext);
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [mustChange, setMustChange] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post("/auth/login", form);
      login(res.data.user, res.data.token);
      if (res.data?.user?.mustChangePassword) {
        setMustChange(true);
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(err.response?.data?.msg || "Login failed");
    }
  };

  const goToReset = () => {
    navigate("/reset-password", { state: { username: form.username } });
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography variant="h5" gutterBottom>
          JASS ERP Login
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            name="username"
            value={form.username}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Password"
            name="password"
            value={form.password}
            onChange={handleChange}
            type="password"
            fullWidth
            margin="normal"
            required
          />
          {error && <Alert severity="error">{error}</Alert>}
          {mustChange && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              You must reset your password to proceed.
            </Alert>
          )}
          <Box mt={2}>
            <Button type="submit" variant="contained" fullWidth>
              Login
            </Button>
          </Box>
          {mustChange && (
            <Box mt={2}>
              <Button variant="outlined" fullWidth onClick={goToReset}>
                Go to Reset Password
              </Button>
            </Box>
          )}
        </form>
      </Paper>
    </Container>
  );
};

export default Login;
